import { TextField } from '@mui/material';
import { ComponentProps, ReactNode } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

interface MuiSelectControlledProps extends ComponentProps<typeof TextField> {
  selectProps: {
    name: string;
    defaultValue?: string;
    label?: string;
    placeholder?: string;
  };
  children: ReactNode;
  styles?: any;
}

export function MuiSelectControlled({
  selectProps,
  children,
  styles = {},
  ...rest
}: MuiSelectControlledProps) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      control={control}
      name={selectProps.name}
      defaultValue={selectProps.defaultValue ?? ''}
      render={({ field }) => (
        <TextField
          id='outlined-select-currency-native'
          select
          label={selectProps.label}
          error={!!errors[selectProps.name]}
          placeholder={selectProps.placeholder}
          fullWidth
          helperText={
            errors[selectProps.name]
              ? String(errors[selectProps.name]?.message)
              : ''
          }
          {...rest}
          {...field}
          {...selectProps}
        >
          {children}
        </TextField>
      )}
    />
  );
}
